import { render, staticRenderFns } from "./ModelCom.vue?vue&type=template&id=164111f8&"
import script from "./ModelCom.vue?vue&type=script&lang=ts&"
export * from "./ModelCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports